import {isNil} from 'ramda';

import {FeatureResponseBody, TranslationResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {isPremiumInteriorMaterial} from '../../../constants/PREMIUM_INTERIOR_MATERIALS';
import {PremiumFeature} from '../types/PremiumFeature';

/**
 * Premium features of a listing - the highlighted ones the vehicle header shows as chips, sorted
 * by name. Features without a translation (the key comes back as the label) are left out.
 * A premium interior material (leather, Alcantara) goes first, with a seat icon.
 */
export const getPremiumFeatures = (
  features: Record<string, FeatureResponseBody> | Nullish,
  interiorMaterial?: TranslationResponseBody | Nullish
): PremiumFeature[] => {
  const highlightedFeatures = Object.values(features ?? {})
    .filter((feature) => feature.isHighlight && feature.key !== feature.translation)
    .map((feature) => ({key: feature.key, label: feature.translation}))
    .sort((a, b) => a.label.localeCompare(b.label));

  if (isNil(interiorMaterial) || !isPremiumInteriorMaterial(interiorMaterial.key)) {
    return highlightedFeatures;
  }

  return [
    {
      key: `interiorMaterial-${interiorMaterial.key}`,
      label: interiorMaterial.translation,
      icon: 'action/event_seat',
      tooltip: i18n.t('entity.vehicle.labels.interiorMaterial'),
    },
    ...highlightedFeatures,
  ];
};
